import { render } from "./LegendColor.vue?vue&type=template&id=bde4ddc6"
import script from "./LegendColor.vue?vue&type=script&lang=js"
export * from "./LegendColor.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__